import React, { createContext, useEffect, useReducer, useRef } from "react";
import { useParams } from "react-router-dom";
import { useIsMobile } from "../helpers";
import { reducer, initialState } from "../reducers";
import { useDataHook } from "../hooks";
import { loadBlocks, loadPapers } from "../api/dataApi";

// Создаем контекст
export const OpredelitelContext = createContext();

// Провайдер контекста
export const OpredelitelProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const refMap = useRef({});
  const { blockId } = useParams();
  const isMobile = useIsMobile(640);
  const { processImages, scrollToRef } = useDataHook(dispatch, isMobile);

  const fetchData = async (type) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      const [blocks, papersData] = await Promise.all([
        loadBlocks(type),
        loadPapers(),
      ]);

      dispatch({
        type: "SET_DATA",
        payload: { blocks, isLoaded: true },
      });
      dispatch({ type: "SET_PAPERS", payload: papersData });
    } catch (err) {
      console.error("Failed to load data:", err);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    let type = state.paperType;
    fetchData(type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update paperType based on blockId after data loads
  useEffect(() => {
    if (blockId && state.data.blocks.length > 0) {
      const block = state.data.blocks.find((b) => b.id === +blockId);
      if (block && state.paperType !== block.paperId) {
        dispatch({ type: "SET_PAPER_TYPE", payload: block.paperId });
        fetchData(block.paperId);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockId, state.data.blocks, state.paperType]);

  // Прокрутка при изменении blockId
  useEffect(() => {
    if (blockId && refMap.current[blockId] && state.data.isLoaded) {
      scrollToRef(refMap.current[blockId]);
    }
  }, [blockId, refMap, scrollToRef, state.data.isLoaded]);

  // Запуск процесса обработки изображений
  useEffect(() => {
    if (state.imagesToLoad.length > 0) {
      processImages({
        isLoaded: state.isLoaded,
        imagesToLoad: state.imagesToLoad,
      });
    }
  }, [state.imagesToLoad, state.isLoaded, processImages]);

  return (
    <OpredelitelContext.Provider
      value={{
        refMap,
        paperType: state.paperType,
        loadedImages: state.loadedImages,
        blocks: state.data.blocks,
        papers: state.papers,
        isLoading: state.isLoading,
        fetchData: fetchData,
        setPaperType: (type) =>
          dispatch({ type: "SET_PAPER_TYPE", payload: type }),
        setImagesToLoad: (image) =>
          dispatch({ type: "SET_IMAGES_TO_LOAD", payload: image }),
      }}
    >
      {children}
    </OpredelitelContext.Provider>
  );
};
